"use client";

import { Heart } from "lucide-react";
import { useWishlistStore } from "@/store/wishlist.store";
import { cn } from "@/lib/utils";
import { useHasHydrated } from "@/hooks/use-has-hydrated";

interface WishlistButtonProps {
  productId: string;
  name: string;
  slug: string;
  price: number;
  coverImageUrl?: string;
  size?: "sm" | "md";
  className?: string;
}

export function WishlistButton({
  productId, name, slug, price, coverImageUrl, size = "md", className,
}: WishlistButtonProps) {
  const { has, toggle } = useWishlistStore();
  const hasHydrated = useHasHydrated();
  const inList = hasHydrated && has(productId);

  return (
    <button
      type="button"
      aria-label={inList ? "Favorilerden çıkar" : "Favorilere ekle"}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        toggle({ productId, name, slug, price, coverImageUrl });
      }}
      className={cn(
        "flex items-center justify-center rounded-full bg-white/90 backdrop-blur-sm border border-gray-200 transition-all hover:scale-110 hover:border-red-300 shadow-sm",
        size === "sm" ? "w-8 h-8" : "w-11 h-11",
        className
      )}
    >
      <Heart
        className={cn(
          "transition-colors",
          size === "sm" ? "w-3 h-3" : "w-4.5 h-4.5",
          inList ? "fill-red-500 text-red-500" : "text-gray-400"
        )}
        style={{ width: size === "sm" ? 12 : 18, height: size === "sm" ? 12 : 18 }}
      />
    </button>
  );
}
